"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBranch = exports.markerPropertyName = void 0; // Generated by CoffeeScript 2.3.2

var markerPropertyName = '__ad-hok-branch'; // eslint-disable-next-line known-imports/no-unused-vars

exports.markerPropertyName = markerPropertyName;

var isBranch = function isBranch(func) {
  return func[markerPropertyName];
};

exports.isBranch = isBranch;